/* eslint-disable max-len */
import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
// import { Events } from '@ionic/angular';
import { OfficeHelperService } from '../../providers/office-helper/office-helper.service';
import { ProfileHelperService } from '../../providers/profile-helper/profile-helper.service';
import { IOffice } from '../../interfaces/profile.interface';
import { IOfficeData } from '../../interfaces/office.interface';
import { HelperProvider } from 'src/app/providers/helper.provider';

@Component({
  selector: 'office-list',
  templateUrl: './office-list.page.html',
  styleUrls: ['./office-list.page.scss'],
})
export class OfficeListPage implements OnInit {
  @ViewChild('scheduleList') scheduleList: any;

  officeList;
  queryText: string;
  error: any;
  filteredOfficeList = [];

  defaultOffice = '64faefc488863301c2d53f93';

  segment;
  shownSessions;
  presentFilter;

  constructor(
    private officeHelper: OfficeHelperService,
    private profileHelper: ProfileHelperService,
    private helperProvider: HelperProvider
    // private events: Events,

  ) { }

  ngOnInit() {
    this.getOfficeList();
  }

  getOfficeList(): void {

    this.officeHelper.getOfficeList()
    .then((data) => {
      this.officeList = data || [];
      this.officeList = this.officeList.filter((ele) => (ele.showOnMobile));
      this.filteredOfficeList = this.officeList;
    }).catch(err => {
      this.error = err;
      console.log(err);
    });
  }

  changeOffice(office: IOfficeData) {
    if (office && office._id) {
      this.profileHelper.updateProfileData({lastSelectedOffice: office._id})
      .then((updated) => {
        this.officeHelper.getOfficeData(office._id)
        .then((officeData: IOfficeData) => {
          if (officeData) {
            window.localStorage.setItem('ngStorage-selectedOffice', JSON.stringify(officeData));
            window.localStorage.setItem('selectedOfficeId', officeData._id);
            // trigger change the office
            this.helperProvider.onEvent.next('user:officeChanged');
          }
        }).catch(err => {
          alert(err);
        });
      }).catch(err => {
        alert(err);
      });
    }
  }

  updateSchedule() {
    // Close any open sliding items when the schedule updates
    if (this.scheduleList) {
      this.scheduleList.closeSlidingItems();
    }
    this.queryText = (this.queryText && this.queryText.toLowerCase()) || '';

    this.officeList = this.officeList || [];
    this.filteredOfficeList = this.officeList.filter(ele => (ele && ele.name && ele.name.toLowerCase() && ele.name.toLowerCase().includes(this.queryText)));
  }
}
